<div class="mt-5 text-center">
  <img ngSrc="assets/images/error-401.svg" alt="Error" height="120" width="auto">
  <h3 class="mt-3 mb-2">Error de autenticación</h3>
  <p class="text-muted mb-3">El enlace que estás usando ha expirado. Por favor, solicita un nuevo enlace.</p>
</div>

